import { getUnifiedAuthConfigUrl } from './Api';
import {
  AuthFlow,
  AuthApiPayload,
  AuthorizeUrlRequest,
} from './UniversalAuthSteps';
import { AuthenticateError } from './LowLevelUnifiedAuth';
import type { HubHttpClient } from './HttpClientContext';

export function fetchAuthConfigForUnifiedAuth(
  http: HubHttpClient,
  portalId: number,
  authenticatorId: string,
  appName: string,
  oAuthScope?: string,
  mcp?: { clientId: string; serverUrl: string } | null,
  appId?: number,
  customParams?: Record<string, string>,
  oAuthScopeSet?: string[]
) {
  return async () => {
    const authFlow = await http.get<AuthFlow>(
      getUnifiedAuthConfigUrl(authenticatorId),
      { query: { portalId, appName } }
    );

    return {
      appName,
      appIcon: '',
      oAuthScope,
      oAuthScopeSet,
      mcp,
      authFlow,
      appId,
      customParams,

      getAuthorizeUrl(request: AuthorizeUrlRequest) {
        return http
          .post<{ authorizeUrl: string }>(
            `unified-auth/v1/authenticators/${authenticatorId}/authorize-url`,
            {
              data: request,
              query: { portalId },
            }
          )
          .then(
            (response: {
              authorizeUrl: string;
              status?: string;
              message?: string;
              upstreamErrorMessage?: string;
            }) => {
              if (
                typeof response === 'object' &&
                'status' in response &&
                response.status === 'error'
              ) {
                throw new AuthenticateError(
                  response.message,
                  response.upstreamErrorMessage
                );
              }
              return response;
            }
          );
      },

      finishAuthFlow(payload: AuthApiPayload): Promise<{ secretId: string }> {
        return http
          .post<{ secretId: string }>(
            `unified-auth/v1/authenticators/${authenticatorId}/secret`,
            {
              data: payload,
              query: { portalId },
              timeout: 35000,
            }
          )
          .then(
            (finishPayload: {
              secretId: string;
              status?: string;
              message?: string;
              upstreamErrorMessage?: string;
            }) => {
              if (
                typeof finishPayload === 'object' &&
                'status' in finishPayload &&
                finishPayload.status === 'error'
              ) {
                throw new AuthenticateError(
                  finishPayload.message,
                  finishPayload.upstreamErrorMessage
                );
              } else {
                return finishPayload;
              }
            }
          );
      },
    };
  };
}
